export default function Unique() {
  const features = [
    {
      number: '01',
      title: 'Formação Exclusiva',
      description: 'Apenas para profissionais e estudantes atuantes. Sem iniciantes.'
    },
    {
      number: '02',
      title: 'Integração Completa',
      description: 'Técnica artística + energia + telepatia + equilíbrio emocional em um único método.'
    },
    {
      number: '03',
      title: 'Presencial Obrigatório',
      description: 'Vivências práticas presenciais com suporte online complementar.'
    },
    {
      number: '04',
      title: 'Referências de Elite',
      description: 'Stanislavski, Stella Adler, Tchekhov, Fátima Toledo, Amit Goswami + fundamentos ICW.'
    },
    {
      number: '05',
      title: 'Resultados Imediatos',
      description: 'Foco em aplicação real no palco, treino, cena e vida profissional.'
    }
  ];

  return (
    <section className="py-32 bg-[#262364] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#F05954] opacity-5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#F05954] opacity-5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-6">
            O Que Torna a AAPEQ Única
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Uma metodologia exclusiva que integra arte, ciência e consciência para resultados extraordinários
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className="text-7xl font-black text-[#F05954] opacity-20 mb-4">
                {feature.number}
              </div>
              <h3 className="text-lg font-bold text-[#262364] mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
